import { h } from "@stencil/core";
export const Label = ({ error = false, errorMsg = "", label = "", labelInfo = "", required = false, htmlFor = null, labelClasses = null, legend = false }) => {
    const errorMessageClass = "ux-label__error-message";
    const labelInfoClass = "ux-label__info";
    const hasErrorMsg = error && errorMsg !== "";
    const hasLabelInfo = labelInfo !== "";
    const hasLabel = label !== "";
    const Tag = legend ? "legend" : "label";
    if (!(hasLabel || hasErrorMsg)) {
        return null;
    }
    return (h(Tag
    // @ts-expect-error Check for typing
    , {
        // @ts-expect-error Check for typing
        htmlFor: htmlFor, class: {
            "ux-label": true,
            "ux-label--error": error && errorMsg === "",
            // @ts-expect-error Check for typing
            [labelClasses]: labelClasses !== null
        }
    }, label, required && h("span", null, " *"), h("span", { onClick: (e) => e.preventDefault() }, h("slot", null)), hasLabelInfo && (h("span", { class: {
            [labelInfoClass]: true
        } }, labelInfo)), hasErrorMsg && (h("span", { class: {
            [errorMessageClass]: true,
            [`${errorMessageClass}--error-only`]: label === "" && !required
        } }, errorMsg))));
};
//# sourceMappingURL=label.js.map
